import { apiClient } from './api';

export const adminUserService = {
  // Create new user
  createUser: async (userData) => {
    const response = await apiClient.post('/users/admin/create', userData);
    return response.data;
  },

  // Get all users with pagination and filters
  getAllUsers: async (page = 1, limit = 10, search = '', status = '', role = '') => {
    const response = await apiClient.get(
      `/users/admin/all?page=${page}&limit=${limit}&search=${search}&status=${status}&role=${role}`
    );
    return response.data;
  },

  // Get user details
  getUserDetails: async (userId) => {
    const response = await apiClient.get(`/users/admin/${userId}`);
    return response.data;
  },

  // Update user
  updateUser: async (userId, data) => {
    const response = await apiClient.put(
      `/users/admin/${userId}`,
      data
    );
    return response.data;
  },

  // Delete user
  deleteUser: async (userId) => {
    const response = await apiClient.delete(`/users/admin/${userId}`);
    return response.data;
  },

  // Change user status
  changeUserStatus: async (userId, status) => {
    const response = await apiClient.patch(
      `/users/admin/${userId}/status`,
      { status }
    );
    return response.data;
  },

  // Make user admin
  makeUserAdmin: async (userId) => {
    const response = await apiClient.patch(
      `/users/admin/${userId}/make-admin`,
      {}
    );
    return response.data;
  },

  // Remove admin privileges
  removeAdminPrivileges: async (userId) => {
    const response = await apiClient.patch(
      `/users/admin/${userId}/remove-admin`,
      {}
    );
    return response.data;
  },

  // Reset user password
  resetUserPassword: async (userId, newPassword) => {
    const response = await apiClient.patch(
      `/users/admin/${userId}/reset-password`,
      { newPassword }
    );
    return response.data;
  }
};
